export default "__VITE_ASSET__a882b817__"